/* global G */
import { pipe } from 'lib/util'
import { usesGetterSetter } from 'trait/uses'
import { canHookInto } from 'trait/can'
import appModuleComposition from 'trait/composition/appmodule'
import actions from '@app/xEcoApm/actions'
import events from '@app/xEcoApm/events'
import hooks from '@app/xEcoApm/hooks'

const descriptor = 'module::x::eco::apm'

/**
 * Ecoclean APM Module
 *
 * @param {Gaia.AppModule.Spec} obj - configuration object
 * @returns {Gaia.AppModule.Spec} obj - object composition
 */
const composition = pipe(
  appModuleComposition(descriptor),
  usesGetterSetter(G.ACTIONS, actions),
  usesGetterSetter(G.EVENTS, events),
  canHookInto(G.ACTIONS, hooks),
)

export default composition
